import { Pipe, PipeTransform } from '@angular/core';
import { IGridSimpleDataGroup } from '../interfaces';

@Pipe({
	name: 'gridShowGroupRow',
	pure: false,
	standalone: true
})
export class NHAGridShowGroupRowPipe implements PipeTransform {
	private static groups: IGridSimpleDataGroup[] = [];

	public static clearGroups(): void {
		NHAGridShowGroupRowPipe.groups = [];
	}

	transform(key: string | ((item: unknown) => string), item: unknown, index: number): boolean {
		let groupKey: string = null;
		if (typeof key === 'function') {
			groupKey = key(item);
		} else {
			groupKey = key;
		}

		let group: IGridSimpleDataGroup = NHAGridShowGroupRowPipe.groups.find((g) => g.key === groupKey);
		if (group === undefined) {
			group = {
				key: groupKey,
				index: index
			};
			NHAGridShowGroupRowPipe.groups.push(group);
		}

		return group.index === index;
	}
}
